import styled from 'styled-components/macro';

export const LocalColumn = styled.div`
  position: relative;
  width: 100%;
  min-height: 100%;
  background-color: ${({ isLocal, theme }) =>
    isLocal ? theme.light : theme.dark4};
`;

export const ShieldBackground = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url(${({ image }) => image});
  background-repeat: no-repeat;
  background-size: 700px;
  background-position: ${({ isLocal }) => (isLocal ? '-239px' : '95px')} center;
  filter: grayscale(100%);
  opacity: 0.1;
  z-index: 0;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    background-size: 500px;
    background-position: -150px -15px;
  }
`;

export const Content = styled.div`
  position: relative;
`;

export const TeamHeader = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: ${({ isLocal }) => (isLocal ? 'row-reverse' : 'row')};
  padding: 0 10px;
  height: 100px;
  font-size: ${({ theme }) => theme.h2}px;
  color: ${({ theme, isLocal }) => (isLocal ? theme.dark : theme.white)};
  background-color: rgba(0, 0, 0, 0.1);

  div {
    display: flex;
    flex-direction: column;

    .name {
      font-size: 24px;
    }

    .alignment {
      font-family: ${({ theme }) => theme.primaryFontLight};
      font-size: 16px;
    }
  }

  img {
    height: ${({ theme }) => theme.shieldBig}px;
    margin: ${({ isLocal }) => (isLocal ? '0 0 0 10px' : '0 10px 0 0')};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: none;
  }
`;

export const SquadContainer = styled.div`
  display: flex;
  z-index: 1;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 0px;
  }

  table {
    padding: 10px;
    @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
      padding: 0px;
    }

    th {
      width: 10%;
      color: ${({ isLocal, theme }) => (isLocal ? theme.dark : theme.white)};
      font-size: ${({ theme }) => theme.paragraph}px;
      font-family: ${({ theme }) => theme.primaryFontBold};
      text-transform: uppercase;
      > div {
        display: block !important;
        text-align: center;
      }

      &:first-child {
        width: 70%;
        > div {
          display: block !important;
          text-align: left;
        }
      }
    }

    td {
      padding: 10px 8px 8px !important;
      font-family: ${({ theme }) => theme.primaryFontBold};
      font-size: ${({ theme }) => theme.paragraphSmall}px;
      font-weight: normal;
      text-transform: uppercase;
      text-align: center;
      span {
        width: 30px;
        font-family: ${({ theme }) => theme.primaryFontBold};
        font-weight: 200;
        display: inline-block;
      }

      &:first-child {
        font-family: ${({ theme }) => theme.primaryFontMedium};
        text-align: left;
      }
    }
  }
`;

export const TeamSubheader = styled.div`
  display: flex;
  z-index: 1;
  position: relative;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-direction: column-reverse;
    align-items: center;
    padding: 10px;
  }
`;

export const TeamSubheaderColumn = styled.div`
  width: 50%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: ${({ isLocal }) => (isLocal ? 'flex-start' : 'flex-end')};

  > div {
    @media (max-width: 1550px) {
      max-width: 250px;
    }
    @media (max-width: 1450px) {
      max-width: 230px;
    }
  }

  h3 {
    margin-top: 5px;
    color: ${({ isLocal, theme }) => (isLocal ? theme.dark : theme.white)};
    text-transform: uppercase;
    margin-bottom: 12px;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
      display: none;
    }
  }

  .trainer {
    color: ${({ isLocal, theme }) => (isLocal ? theme.dark : theme.white)};
    padding-top: 26px;

    span {
      display: block;
      font-size: ${({ theme }) => theme.paragraph}px;
      text-transform: uppercase;
    }

    strong {
      text-transform: none;
      font-size: ${({ theme }) => theme.paragraphBig}px;
      font-weight: normal;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    text-align: center;
    align-items: center;
    padding: 10px 0 0;
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    margin-top: -80px;
  }
`;

export const TeamSquad = styled.div`
  height: 100%;
  z-index: 1;
  flex-grow: 1;
  position: relative;

  > div {
    flex-direction: ${({ isLocal }) => (isLocal ? 'row-reverse' : 'row')};
    padding: 0 10px;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
      flex-direction: row;
    }

    .scroll {
      @media (min-width: 1601px) {
        margin-top: -200px;
      }

      @media (max-width: 1600px) and (min-width: ${({ theme }) =>
          theme.breakpoints.md}px) {
        margin-top: -180px;
      }
    }
  }
`;
